import { Component, OnInit } from '@angular/core';
import { BaseDialog } from '../../../components/dialogs/basedialog/base.dialog';
import { ArrayHelpers } from '../../../helpers/array.helpers';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { TranslatedString } from '../../../models/translatedstring.model';
import { TranslateHelper } from '../../../helpers/injector.helper';
import { MediaService } from '../../../services/media.service';

@Component({
    selector: 'page-documentation-edit-dialog',
    templateUrl: './page.documentation.edit.dialog.html'
})
export class PageDocumentationEditDialog implements OnInit {

    Layout;
    Description: any = {};
    AllDocObjects = [];
    ScreenShotObject;
    AttributeList = [
        '@@Beschreibung',
        '@@Versionsnummer',
        '@@Verantwortlicher',
        '@@Hauptprozess',
        '@@Teilprozess'
    ];
    MediaSources = [];

    static ShowDialog(docDesc, layout, handler) {
        BaseDialog.ShowDialog({
            ContentType: PageDocumentationEditDialog,
            InitArgs: {
                Description: docDesc,
                Layout: layout
            },
            Handler: handler,
            Title: '@@Definition'
        });
    }

    private static FindDocObjects(layout, result, screenShotElement) {
        if (layout) {
            if (screenShotElement && layout.ID == screenShotElement) {
                result.ScreenShotObject = {
                    ID: layout.ID,
                    Name: layout.Name
                }
            }
            if (layout.ElementType == 'documentation') {
                const selected = result.Selected.find(x => x.ID == layout.ID);
                if (selected) {
                    selected.Name = layout.Name;
                    selected.Selected = true;
                } else {
                    result.Unselected.push({
                        ID: layout.ID,
                        Name: layout.Name,
                        Selected: false
                    });
                }
            } else if (layout.Elements) {
                layout.Elements.forEach(x => {
                    PageDocumentationEditDialog.FindDocObjects(x, result, screenShotElement);
                });
            }
        }
    }

    constructor(private mediaService: MediaService) {
    }

    ngOnInit(): void {
        this.mediaService.GetUsable().subscribe((data) => {
            if (data) {
                this.MediaSources = data;
            }
        });
        const result = {
            Selected: [],
            Unselected: [],
            ScreenShotObject: {
                Name: ''
            }
        };
        if (this.Description.DocumentObjects) {
            this.Description.DocumentObjects.forEach(x => {
                result.Selected.push({
                    ID: x,
                    Selected: false
                });
            });
        }
        PageDocumentationEditDialog.FindDocObjects(this.Layout, result, this.Description.ScreenshotObject);
        const objList = [];
        result.Selected.forEach(x => {
            if (x.Selected) {
                objList.push(x);
            }
        });
        ArrayHelpers.sortAlphabetical(result.Unselected, 'Name');
        objList.push(...result.Unselected);
        this.AllDocObjects = objList;
        this.ScreenShotObject = result.ScreenShotObject;
    }

    Initialize(args) {
        if (args) {
            this.Layout = args.Layout;
            if (args.Description) {
                this.Description = JSON.parse(JSON.stringify(args.Description));
            }
        }
    }

    GetDialogResult() {
        const docObjects = [];
        this.AllDocObjects.forEach(x => {
            if (x.Selected) {
                docObjects.push(x.ID);
            }
        });
        this.Description.DocumentObjects = docObjects;
        return this.Description;
    }

    nodeSelected(ev) {
        if (ev && ev.data) {
            this.Description.ScreenshotObject = ev.data.ID;
            this.ScreenShotObject = {
                ID: ev.data.ID,
                Name: ev.data.Name
            };
        }
    }

    onDocDrop(ev) {
        if (this.AllDocObjects && ev && ev.currentIndex !== ev.previousIndex) {
            moveItemInArray(this.AllDocObjects, ev.previousIndex, ev.currentIndex);
        }
    }

    addAttribute(att) {
        if (att) {
            att = TranslateHelper.TranslatorInstance.instant(att);
        } else {
            att = '';
        }
        const entry = {
            Key: new TranslatedString(att),
            Value: new TranslatedString()
        };
        if (this.Description.Attributes) {
            this.Description.Attributes.push(entry);
        } else {
            this.Description.Attributes = [entry];
        }
    }

    onAttrDrop(ev) {
        if (this.Description.Attributes && ev && ev.currentIndex !== ev.previousIndex) {
            moveItemInArray(this.Description.Attributes, ev.previousIndex, ev.currentIndex);
        }
    }

    deleteAttr(i) {
        if (this.Description.Attributes && i > -1 && i < this.Description.Attributes.length) {
            this.Description.Attributes.splice(i, 1);
        }
    }
}
